import React from "react";

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export default function AppFieldGrid({ columns = 2, size = "md", className = "", style, children }) {
  const normalizedColumns = clamp(Number(columns) || 2, 1, 4);
  const sizeClass =
    size === "sm" ? "ds-field-grid--sm" : size === "lg" ? "ds-field-grid--lg" : "ds-field-grid--md";
  const classes = ["ds-field-grid", `ds-field-grid--cols-${normalizedColumns}`, sizeClass, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} style={style}>
      {React.Children.map(children, (child, index) => {
        if (child === null || child === undefined || child === false) {
          return null;
        }

        const rawSpan = React.isValidElement(child) ? Number(child.props.span ?? 1) : 1;
        const normalizedSpan = clamp(Number.isFinite(rawSpan) ? rawSpan : 1, 1, normalizedColumns);
        const itemClasses = [
          "ds-field-grid__item",
          normalizedSpan > 1 ? `ds-field-grid__item--span-${normalizedSpan}` : "",
        ]
          .filter(Boolean)
          .join(" ");

        return (
          <div className={itemClasses} key={React.isValidElement(child) && child.key != null ? child.key : index}>
            {child}
          </div>
        );
      })}
    </div>
  );
}
